<template>
    <div class="string text-4xl" ref="parallaxText" 
    :data-scroll="scrollTop" 
    :position="elementPosition"
    :height ="maxHeight"
    :class="isPage ? ( getScreenHeight > elementPosition + 600 ? 'is-active' : 'no-active') 
    : (elementPosition < containerRec.height ? 'isactive' : 'opacity-0')
    ">
        <slot></slot>
    </div>
</template>

<script>

import {onIntersect} from "../../scripts/onintersect"
export default {
    name: "parallax-text",
    props: {
        scrollTop: {
            type: Number,
            default: 0
        },
        container: {
            type: Object,
            default: () => { }
        },
        isPage:{
            type:Boolean,
            default:false
        }
    },
    
    data() {
        return {
            intersect:false,
            maxHeight:0,
            elem: null,
            elementPosition: 0,
            posFromTopContainer: 0,
            parentPos: () => { },
            containerRec:() =>{},
            parallaxTextRec: () => { },
           
          
            
        }
    },
    computed:{
        getScreenHeight(){
            return window.innerHeight
        }
    },
    methods: {
        scrollTextInitPage(){
            this.containerRec = this.container.offsetParent.getBoundingClientRect()
            this.maxHeight = this.containerRec.height 
           this.elementPosition =  this.$refs.parallaxText.offsetTop //this.parallaxTextRec.top - this.containerRec.top
            //addEventListener('scroll', this.handleScrollPage) 
         
            const options = {
                root: null,
                rootMargins: '0px',
                threshold: 0.03
            }
            onIntersect(this.$refs.parallaxText, this.handlerEnter, this.handlerOut, false, options)
            
        },

        handlerEnter(elem){
            this.intersect= true
            elem.classList.remove('no-active')
            elem.classList.add('active')
           
        },
        handlerOut(elem){
            this.intersect = false
            elem.classList.remove('active');
            elem.classList.add('no-active')
        },

        scrollTextInitBox(){
        const cbottom = this.containerRec.bottom
        const containerTop = this.containerRec.top
        this.elementPosition = this.parallaxTextRec.bottom - containerTop 
        this.parent = this.elem.parentElement
        this.parentPos = this.elem.parentElement.getBoundingClientRect();
        this.parent.addEventListener('scroll', this.handlerTextScroll_2)
        },






        handleScrollPage(e){
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const rawObjectData = {...this.$data}
            const {elementPosition, elem, maxHeight} = rawObjectData
            let max = maxHeight - 150 //((maxHeight/100)*10) 
            if(scrollTop <= 0 || 300 + scrollTop < elementPosition ){
                elem.classList.remove('active');
            }
            else if (scrollTop > elementPosition  ){
                elem.classList.add('active')
            }
            
        },
        handlerTextScroll_2(e){
            const scrollTop = e.target.scrollTop
            const rawObjectData = {...this.$data}
            const {parallaxTextRec,containerRec, elem } = rawObjectData
            this.posFromTopContainer = scrollTop
            const elementPosition = (parallaxTextRec.bottom - containerRec.bottom ) - ((containerRec.bottom/100)*5)
            if( scrollTop == 0 || containerRec.top == 0 || elementPosition > scrollTop   ){
                elem.classList.remove('active')
            }
            else if (elementPosition  < scrollTop) {
                elem.classList.add('active')
            }
        },

    },
    mounted() {
        this.elem = this.$refs.parallaxText;
        this.parallaxTextRec = this.elem.getBoundingClientRect()
        this.containerRec = this.container.getBoundingClientRect()
        this.isPage ? this.scrollTextInitPage() : this.scrollTextInitBox()
        
        
    },
}


</script>

<style lang="scss" scoped>
.string,.isactive {
    transform: translateY(0);
    transition: .2s cubic-bezier(0.4, 0, 1, 1);
    h1{
        font-size: 40px;
        font-weight: 600;
    }
    h4{
        font-weight: 400;
        font-size: 20px;
    }
    &.active{
        opacity:1;
        transform: translateY(-100px);
        transition: .6s cubic-bezier(0.4, 0, 1, 1);
    }
    &.no-active{
        opacity:0;
        transform: translateY(-0px);
        transition: .2s cubic-bezier(0.4, 0, 1, 1);
    }
}
</style>